import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import "./mui-box-table.scss";
import { MUIBoxTableProps } from "./mui-table-props";
import CustomTooltip from "./custom-tooltip";

const MUIBoxTable = <T extends Record<string, any>>({
  columns,
  data,
  noResultText,
  onRowClick,
}: MUIBoxTableProps<T>) => {
  return (
    <TableContainer component={Paper} className="box-table-container">
      <Table className="box-table">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.key}
                className="box-table-cell box-table-head"
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody className="box-table-body-cell-scrollable">
          {data.length > 0 ? (
            data.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                className={onRowClick ? "clickable-row" : "box-table-body-row"}
                onClick={() => onRowClick && onRowClick(row)}
              >
                {columns.map((column) => {
                  const cellValue = column.render
                    ? column.render(row)
                    : row[column.key];

                  const isText =
                    typeof cellValue === "string" ||
                    typeof cellValue === "number";

                  return (
                    <TableCell key={column.key} className="box-table-cell">
                      {column.disableTooltip ? (
                        // Completely skip tooltip
                        <>{cellValue}</>
                      ) : isText ? (
                        <CustomTooltip
                          title={cellValue}
                          arrow
                          placement="top-start"
                        >
                          <span className="cell-ellipsis">{cellValue}</span>
                        </CustomTooltip>
                      ) : (cellValue?.props?.children ||
                          cellValue?.props?.children === 0) &&
                        column.key !== "action" ? (
                        <CustomTooltip
                          title={cellValue?.props?.children}
                          arrow
                          placement="top-start"
                        >
                          {cellValue ?? "-"}
                        </CustomTooltip>
                      ) : (
                        (cellValue ?? "-")
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} className="no-data">
                {noResultText || "No data found"}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MUIBoxTable;
